export function datadogAddContext(ddObj) {
  if (window.preDataLayer) {
    try {
      var stringProducts = JSON.stringify(window.preDataLayer.transactionProducts)
    } catch (e) {}

    ddObj.setGlobalContextProperty('checkoutStep', window.preDataLayer.eeCheckoutStep)
    ddObj.setGlobalContextProperty('language', window.preDataLayer.lang)
    ddObj.setGlobalContextProperty('template', window.preDataLayer.path)
    ddObj.setGlobalContextProperty('webuser', window.preDataLayer.webuser)
    ddObj.setGlobalContextProperty('products', stringProducts)
    //ddObj.setGlobalContextProperty('preDataLayer', window.preDataLayer)
    ddObj.setGlobalContextProperty('useragent', navigator.userAgent)
    ddObj.setGlobalContextProperty('HTMLTemplateFile', window.homair.template)
    ddObj.setGlobalContextProperty('appname', 'resalys_tpl')
  }

  if (window.homair && window.homair.getAddToCartParams) {
    ddObj.setGlobalContextProperty('addToCartData', window.homair.getAddToCartParams())
  }
  ddObj.setGlobalContextProperty(
    'cm_cookies',
    document.cookie.split(';').filter(function (c) {
      return c.indexOf('CM_') !== -1
    }),
  )
}
